import axios from 'axios';
import { UPDATE_WELL_API_URL, UPDATE_HIGHWAY_LINE_API_URL, UPDATE_PILLAR_API_URL, UPDATE_COUPLING_API_URL, UPDATE_FOB_API_URL,
    UPDATE_HIGHWAY_LINE_CONTRACT_NUMBER_API_URL, UPDATE_HIGHWAY_LINE_LENGTH_ACT_API_URL, UPDATE_HIGHWAY_LINE_CABLE_API_URL, UPDATE_PON_BOX_API_URL,
    UPDATE_COUPLING_NAME_API_URL, UPDATE_FOB_NAME_API_URL, UPDATE_PON_BOX_NAME_API_URL, UPDATE_COUPLING_RANK_API_URL,
    UPDATE_FOB_RANK_API_URL, UPDATE_WELL_OWNER_API_URL, UPDATE_PILLAR_OWNER_API_URL, UPDATE_HIGHWAY_CONTRACTOR_CABLE_API_URL,
    UPDATE_HIGHWAY_ENGINNER_CABLE_API_URL, UPDATE_HIGHWAY_LINE_CABLE_NUMBER_API_URL, UPDATE_WELL_COORDINATE_URL, 
    UPDATE_PILLAR_COORDINATE_URL,
    UPDATE_COUPLING_COORDINATE_URL,
    UPDATE_FOB_COORDINATE_URL,
    UPDATE_PONBOX_COORDINATE_URL,
    UPDATE_HIGHWAY_TYPE_CABLE_API_URL,
    UPDATE_AMPLIFIER_MODEL_API_URL,
    UPDATE_OP_MODEL_API_URL,
    UPDATE_PON_BOX_COMING_API_URL,
    UPDATE_DIVIDER_MODEL_API_URL,
    UPDATE_DIVIDER_DESCRIPTION_API_URL,
    UPDATE_DIVIDER_MODEL_PONBOX_API_URL,
    UPDATE_FOB_RANK_NODE_API_URL,
    UPDATE_RANK_CABLE_API_URL,
    UPDATE_CASSETTE_MODEL_API_URL,
    UPDATE_CASSETTE_DESCRIPTION_API_URL,
    UPDATE_DIVIDER_2_MODEL_PONBOX_API_URL,
    UPDATE_PONBOX_NUMBER_BOX_API_URL,
    UPDATE_PASSIVE_NODE_DESCROPTION_API_URL,
    UPDATE_PASSIVE_NODE_COORDINATE_URL,
    UPDATE_RESERVE_MODEL_API_URL,
    UPDATE_RESERVE_API_URL,
    UPDATE_RESERVE_DESCRIPTION_API_URL} from '../OpticApiConfig';

// обновление Well
export const UpdateWell = (id, textComment, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    axios.patch(`${UPDATE_WELL_API_URL}${id}`, { comment: textComment, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Well owner
export const UpdateWellOwner= (id, ownerWellId, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_WELL_OWNER_API_URL}${id}`, { ownerWellId: ownerWellId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Well coordinate map
export const UpdateWellCoordinate= (id, latitude, longitude, user,  refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
       // showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_WELL_COORDINATE_URL}${id}`, { latitude: latitude, longitude: longitude, authorId: user }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
       // showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
      //  showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Pillar coordinate map
export const UpdatePillarCoordinate= (id, latitude, longitude, user,  refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
       // showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_PILLAR_COORDINATE_URL}${id}`, { latitude: latitude, longitude: longitude, authorId: user }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
       // showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
      //  showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Coupling coordinate map
export const UpdateCouplingCoordinate= (id, latitude, longitude, user,  refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
       // showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_COUPLING_COORDINATE_URL}${id}`, { latitude: latitude, longitude: longitude, authorId: user }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
       // showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
      //  showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Fob coordinate map
export const UpdateFobCoordinate= (id, latitude, longitude, user,  refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
       // showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_FOB_COORDINATE_URL}${id}`, { latitude: latitude, longitude: longitude, authorId: user }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
       // showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
      //  showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление PassiveNode coordinate map
export const UpdatePassiveNodeCoordinate= (id, latitude, longitude, user,  refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
       // showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_PASSIVE_NODE_COORDINATE_URL}${id}`, { latitude: latitude, longitude: longitude, authorId: user }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
       // showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
      //  showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление PonBox coordinate map
export const UpdatePonBoxCoordinate= (id, latitude, longitude, user,  refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
       // showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_PONBOX_COORDINATE_URL}${id}`, { latitude: latitude, longitude: longitude, authorId: user }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
       // showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
      //  showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление HighwayLine
export const UpdateHighwayLine = (id, textComment, showSnackbar, authorId, refresh, cantonCablaByIdRefresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    axios.patch(`${UPDATE_HIGHWAY_LINE_API_URL}${id}`, { comment: textComment, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        //refresh();
        cantonCablaByIdRefresh(id);
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление HighwayLine ContractNumber
export const UpdateHighwayLineContractNumber = (id, textContractNumber, showSnackbar, authorId, refresh, cantonCablaByIdRefresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    axios.patch(`${UPDATE_HIGHWAY_LINE_CONTRACT_NUMBER_API_URL}${id}`, { contractNumber: textContractNumber, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        cantonCablaByIdRefresh(id);
        //refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление HighwayLine CableNumber
export const UpdateHighwayLineCableNumber = (id, textCableNumber, showSnackbar, authorId, refresh, cantonCablaByIdRefresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    axios.patch(`${UPDATE_HIGHWAY_LINE_CABLE_NUMBER_API_URL}${id}`, { cableNumber: textCableNumber, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        cantonCablaByIdRefresh(id);
        //refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление HighwayLine LengthAct
export const UpdateHighwayLineLengthAct= (id, lengthAct, showSnackbar, authorId, refresh, cantonCablaByIdRefresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_HIGHWAY_LINE_LENGTH_ACT_API_URL}${id}`, { lengthAct: lengthAct, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        //refresh();
        cantonCablaByIdRefresh(id);
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление HighwayLine Cable
export const UpdateHighwayLineCable= (id, CableId, showSnackbar, authorId, refresh, cantonCablaByIdRefresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_HIGHWAY_LINE_CABLE_API_URL}${id}`, { cableId: CableId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        cantonCablaByIdRefresh(id);
        //refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Cable Contractor
export const UpdateContractor= (id, contractorId, showSnackbar, authorId, refresh, cantonCablaByIdRefresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_HIGHWAY_CONTRACTOR_CABLE_API_URL}${id}`, { contractorId: contractorId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        cantonCablaByIdRefresh(id);
        //refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Cable Type
export const UpdateTypeCable= (id, typeId, showSnackbar, authorId, refresh, cantonCablaByIdRefresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_HIGHWAY_TYPE_CABLE_API_URL}${id}`, { typeId: typeId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
       // refresh();
        cantonCablaByIdRefresh(id);
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Cable Rank
export const UpdateRankCable= (id, rankId, showSnackbar, authorId, refresh, cantonCablaByIdRefresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_RANK_CABLE_API_URL}${id}`, { typeId: rankId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        cantonCablaByIdRefresh(id);
        //refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Cable Engineer
export const UpdateHighwayLineEngineer= (id, textEngineer, showSnackbar, authorId, refresh, cantonCablaByIdRefresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_HIGHWAY_ENGINNER_CABLE_API_URL}${id}`, { engineer: textEngineer, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        cantonCablaByIdRefresh(id);
        //refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Pillar
export const UpdatePillar = (id, textComment, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    axios.patch(`${UPDATE_PILLAR_API_URL}${id}`, { comment: textComment, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Pillar owner
export const UpdatePillarOwner= (id, ownerPillarId, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_PILLAR_OWNER_API_URL}${id}`, { ownerPillarId: ownerPillarId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Coupling coment
export const UpdateCoupling = (id, textComment, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    axios.patch(`${UPDATE_COUPLING_API_URL}${id}`, { comment: textComment, authorId: authorId },{
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Coupling name
export const UpdateCouplingName= (id, couplingId, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_COUPLING_NAME_API_URL}${id}`, { couplingId: couplingId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Coupling rank
export const UpdateCouplingRank= (id, couplingRankId, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_COUPLING_RANK_API_URL}${id}`, { rankComponentId: couplingRankId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Fob
export const UpdateFob = (id, textComment, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    axios.patch(`${UPDATE_FOB_API_URL}${id}`, { comment: textComment, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        showSnackbar('Ошибка! Данные не обновлены');
    });
};




// обновление Fob name
export const UpdateFobName= (id, fobId, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_FOB_NAME_API_URL}${id}`, { fobId: fobId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};


// обновление Fob rank
export const UpdateFobRank= (id, fobRankId, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_FOB_RANK_API_URL}${id}`, { rankComponentId: fobRankId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Fob rank NODE
export const UpdateFobRankNode= (id, fobRankId, showSnackbar, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_FOB_RANK_NODE_API_URL}${id}`, { rankComponentId: fobRankId}, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};
// обновление Pon-box
export const UpdatePonBox = (id, textComment, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    axios.patch(`${UPDATE_PON_BOX_API_URL}${id}`, { comment: textComment, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление ПОН-БОКС name
export const UpdatePonBoxName= (id, ponBoxId, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_PON_BOX_NAME_API_URL}${id}`, { ponBoxId: ponBoxId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление PonBox Coming
export const UpdatePonBoxComing= (id, comingId, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_PON_BOX_COMING_API_URL}${id}`, { ponBoxId: comingId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};


// обновление Amplifier model
export const UpdateAmplifierModel= (id, amplifierId, showSnackbar, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_AMPLIFIER_MODEL_API_URL}${id}`, { modelId: amplifierId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Reserve model
export const UpdateReserveModel= (id, reserveId, showSnackbar, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    axios.patch(`${UPDATE_RESERVE_MODEL_API_URL}${id}`, { reservId: reserveId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        //refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};


// обновление OP model
export const UpdateOpModel= (id, opId, showSnackbar, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_OP_MODEL_API_URL}${id}`, { modelId: opId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Divider model NODE
export const UpdateDividerModel= (id, dividerId, showSnackbar) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_DIVIDER_MODEL_API_URL}${id}`, { modelId: dividerId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Divider №1 model PonBox
export const UpdateDividerModelPonBox= (id, dividerId, authorId, showSnackbar, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_DIVIDER_MODEL_PONBOX_API_URL}${id}`, { ponBoxId: dividerId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Divider №2 model PonBox
export const UpdateDivider2ModelPonBox= (id, dividerId, authorId, showSnackbar, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_DIVIDER_2_MODEL_PONBOX_API_URL}${id}`, { ponBoxId: dividerId, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Divider description
export const UpdateDividerDescription = (id, textComment, showSnackbar) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    axios.patch(`${UPDATE_DIVIDER_DESCRIPTION_API_URL}${id}`, { comment: textComment, authorId: 'null' }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Reserve description
export const UpdateReserveDescription = (id, textComment, showSnackbar) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    axios.patch(`${UPDATE_RESERVE_DESCRIPTION_API_URL}${id}`, { comment: textComment, authorId: 'null' }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Cassette model
export const UpdateCassetteModel= (id, cassetteId, showSnackbar) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_CASSETTE_MODEL_API_URL}${id}`, { modelId: cassetteId}, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};

// обновление Cassette description
export const UpdateCassetteDescription = (id, textComment, showSnackbar) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    axios.patch(`${UPDATE_CASSETTE_DESCRIPTION_API_URL}${id}`, { comment: textComment, authorId: 'null' }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        showSnackbar('Ошибка! Данные не обновлены');
    });
};


// обновление PonBox numberBox
export const UpdateNumberPonBox= (id, textNumberBox, showSnackbar, authorId, refresh) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    
    axios.patch(`${UPDATE_PONBOX_NUMBER_BOX_API_URL}${id}`, { engineer: textNumberBox, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        console.log(error)
        showSnackbar('Ошибка! Данные не обновлены');
    });
};


// обновление PassiveNode Description
export const UpdatePassiveNodeDescription = (id, textComment, showSnackbar, authorId, refresh, setIsEditingDescription) => {
    const token = localStorage.getItem('token');
    if (!token) {
        showSnackbar('Ошибка! Токен не найден');
        return;
    }
    axios.patch(`${UPDATE_PASSIVE_NODE_DESCROPTION_API_URL}${id}`, { comment: textComment, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
        setIsEditingDescription(false)
        refresh();
        showSnackbar('Данные успешно обновлены');
    })
    .catch(error => {
        showSnackbar('Ошибка! Данные не обновлены');
    });
};


